<template>
  <div>
    <v-select 
      v-model="form.phoneCode"
      :items="options"
      item-title="name"
      item-value="dial_code"
      v-bind="$attrs"
      required
      @change="onSelect"
    >
      <template v-slot:prepend-item>
        <v-list-item class="py-1 item-sticky">
          <v-text-field
            v-model="searchCountry"
            variant="outlined"
            :placeholder="$t('search')"
            prepend-inner-icon="mdi-magnify"
            hide-details
            density="compact"
          ></v-text-field>
        </v-list-item>
        <v-list-item v-if="optionLength == 0">
          <div class="text-center">
            <span>{{ $t('noData') }}</span>
          </div>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item }">
        {{ item.value }}
      </template>
      <template v-slot:item="{ item, props }">
        <v-list-item v-bind="props" v-if="filteredCountries(item.title)">
          <template v-slot:prepend>
            <img :src="item.raw.flag_image" class="mr-2" width="30" style="border-radius: 50%;" alt="flag" />
          </template>
          <template v-slot:title>
            {{ item.title }} ({{ item.value }})
          </template>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import Countries from '../data/countries.json'
export default {
  props: {
    // value: String,
    phoneCode: {
      type: String,
      default: '+66'
    },
    countryName: String,
    countryCode: String,
    flagImage: String,
  },
  data() {
    return {
      Countries,
      searchCountry: '',
      form: {
        phoneCode: this.phoneCode
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.updateValue()
      }
    }
  },
  created() {
    this.updateValue()
  },
  computed: {
    options() {
      return this.Countries.filter(country => country.continent == "Asia")
    },
    optionLength() {
      return this.options.filter(country => country.name.toLowerCase().includes(this.searchCountry.toLowerCase())).length
    }
  },
  methods: {
    filteredCountries(title) {
      if (title) {
        return title.toLowerCase().includes(this.searchCountry.toLowerCase())
      } else {
        return true
      }
    },
    updateValue(value) {
      let data = this.options.find(country => country.dial_code == this.form.phoneCode)
      this.$emit("update:phoneCode", this.form.phoneCode)
      this.$emit("update:countryName", data.name)
      this.$emit("update:countryCode", data.code)
      this.$emit("update:flagImage", data.flag_image) 
    },
    onSelect() {
      let data = this.options.find(country => country.dial_code == this.form.phoneCode)
      this.$emit("update:phoneCode", data.dial_code)
      this.$emit("update:countryName", data.name)
      this.$emit("update:countryCode", data.code)
      this.$emit("update:flagImage", data.flag_image)
      this.$emit("onSelect", {
        countryName: data.name,
        countryCode: data.dial_code,
        flagImage: data.flag_image
      })
    }
  }
  
}
</script>

<style lang="scss" scoped>
.custom-dropdown  {
  margin: 100px !important;
  padding: 100px !important;
}
.v-list {
  padding: 0 !important;
}
.item-sticky {
  position: sticky;
  top: -8px;
  z-index: 1;
  background-color: white;
  border: 1px solid #e0e0e0;
  margin-top: -8px;
  min-width: 300px;
}
</style>